import { DiscountCampaignMessageCode } from 'app/api/marketing/discount-campaign/constant'
import R from 'app/assets/R'
import { _DEV_ } from 'app/constant'
import { notificationController } from 'app/controllers/notification-controller'
import { useDeActivatedDiscountCampaign } from 'app/react-query/hook/campaign'
import { isEqual } from 'lodash'
import { ResponseType } from 'parkway-web-common'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IPropsReActivated } from './type'

export const useModalHook = (props: IPropsReActivated) => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)
  const { mutateAsync: mutateAsyncChangeDeActivated, isLoading } =
    useDeActivatedDiscountCampaign()

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
  }

  const handleSubmit = async () => {
    if (!props?.id) return
    try {
      const response: ResponseType<unknown> = await mutateAsyncChangeDeActivated?.({
        id: props?.id,
      })

      if (
        isEqual(
          response?.msgcode,
          DiscountCampaignMessageCode.DiscountCampaign.success,
        )
      ) {
        handleCancel()
        notificationController.success({
          message: t(R.strings.reactivate_campaign),
          description: t(R.strings.reactivate_campaign_success),
        })
      } else {
        notificationController.error({
          message: t(R.strings.reactivate_campaign),
          description: response?.message,
        })
      }
    } catch (error) {
      _DEV_ && console.log('error', error)
    }
  }

  return {
    visible,
    t,
    isLoading,
    showModal,
    handleSubmit,
    handleCancel,
  }
}
